import {useState} from 'react';
import { data } from './data';
import plus from 'assets/images/svg/plus.svg'
import st from './AreasOfWork.module.scss';

const Item = ({ data, hasOpen })=> {
    const [isOpen, setIsOpen] = useState(hasOpen)
    const onToggle = ()=> setIsOpen(!isOpen)
    return (
        <div className={st.list_item}>
            <div onClick={onToggle} className={st.list_head}>
                <div>{data.title}</div>
                <div className={st.list_plus + ` ${isOpen ? st.list_plus_open : ''}`}>
                    <img src={plus} alt=""/>
                </div>
            </div>
            {isOpen &&
                <div className={st.list_body} dangerouslySetInnerHTML={{__html: data.content(st)}} />
            }
        </div>
    )
}

export const List = () => {
    return (
        <div className={st.list}>
            {data.map(item => <Item data={item} hasOpen={item.id === 1}  key={item.id} />)}
        </div>
    )
}
